import Config from "./config/config";

console.log(Config.api);
export default {
  modules: {
    authentication: {
      strict: true,
      namespaced: true,
      state: {
			authToken: Config.getCookie("auth") != "" ? Config.getCookie("auth") : null,
			name: Config.getCookie("name") != "" ? Config.getCookie("name") : null,
			account_type: Config.getCookie("account_type") != "" ? Config.getCookie("account_type") : null,
			loggedIn: Config.getCookie("auth") != "" ? true : false,
			lock: Config.getCookie("lock") == "sa" ? false : true,
			mode: Config.getCookie("mode") == "driver" ? "driver" : "normal"
      },
      mutations: {
        login (state, data) {
          state.loggedIn = true
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store.js